import React, { useEffect, useState, useContext, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent } from '@ionic/react';

// Components
import { HeaderComponent, MobileHistoryComponent } from '../../../components';

// Helpers
import { extractConfigPage } from '../../../helpers';

// Contexts
import { AppContext } from '../../../contexts';

// Constants
import { APP_CONFIG } from '../../../constants';

// Actions
import { resetTransactionAction } from '../../../redux';

// Sass
import './HistoryPage.scss';


export const HistoryPage = () => {

    
    const dispatch = useDispatch();
    const { isWeb, network } = useContext(AppContext);
    const location = useLocation();
    const pageConfig = extractConfigPage(location);
    const contentRef = useRef();
    const [showFabButton, setShowFabButton] = useState(false);

    const paginationInitialState = {

        size: isWeb ? APP_CONFIG.PAGINATION.WEB.SIZE : APP_CONFIG.PAGINATION.MOBILE.SIZE,
        page: isWeb ? APP_CONFIG.PAGINATION.WEB.PAGE : APP_CONFIG.PAGINATION.MOBILE.PAGE
    };
    const [pagination, setPagination] = useState(paginationInitialState);

    const params = {};

    /**
     * Setea los datos de paginación
     */
    useEffect(() => {

        if (network.connected) {

            setPagination(paginationInitialState);
        }
        else {
            dispatch(resetTransactionAction());
        }

    }, [network.connected]);

    /**
     * Actualiza la paginación
     */
    const handlePageChange = () => {

        setPagination({
            size: pagination.size,
            page: pagination.page + 1
        });
    };

    /**
     * Maneja el evento del scroll del IonContent
     * @param {Event} e Evento
     */
    const handleScroll = (e) => {

        contentRef.current.getScrollElement()
            .then((el) => {

                setShowFabButton(el.scrollTop > pageConfig.fabButton.scrollFabHeight);
            });
    };

    return (
        <>
            <HeaderComponent
                title={pageConfig.title}
            />

            <IonContent
                ref={contentRef}
                className="ion-no-padding"
                scrollEvents={!isWeb}
                onIonScroll={handleScroll}
            >

                {isWeb &&
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonCard>
                                    <IonCardContent className="ion-text-center">
                                        <MobileHistoryComponent
                                            params={params}
                                            pagination={pagination}
                                            handlePageChange={handlePageChange}
                                            showFabButton={showFabButton}
                                            contentRef={contentRef}
                                            pageConfig={pageConfig}
                                            resetPagination={ () => setPagination(paginationInitialState) }
                                        />
                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>

                    </IonGrid>
                }

                {
                    !isWeb &&
                    <MobileHistoryComponent
                        params={params}
                        pagination={pagination}
                        handlePageChange={handlePageChange}
                        showFabButton={showFabButton}
                        contentRef={contentRef}
                        pageConfig={pageConfig}
                        resetPagination={ () => setPagination(paginationInitialState) }
                    />
                }

            </IonContent>
        </>
    )
}
